import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { types } from "../../events/message";
import { dispatch, eventListener, removeEventListener } from "../../events";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        zIndex: 1000,
        bottom: 0
    },
    messageCard: {
        backgroundColor: "#32b7ff",
        color: "white",
        width: "300px",
        height: "50px",
        marginBottom: "5px",
        marginLeft: "5px",
        display: "table",
        textAlign: "center"
    },
    messageContent: {
        display: "table-cell",
        verticalAlign: "middle"
    }
}));

const Messages = ({ }) => {
    const classes = useStyles();
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        eventListener(types.SET_MESSAGE, addMessage);
        eventListener(types.DELETE_MESSAGE, deleteMessage);
        return () => {
            removeEventListener(types.SET_MESSAGE, addMessage)
            removeEventListener(types.DELETE_MESSAGE, deleteMessage)
        }
    }, [messages]);

    const addMessage = (event) => {
        const message = { id: Math.floor(Math.random() * 10000000), content: event.values };
        setTimeout(() => {
            dispatch(types.DELETE_MESSAGE, message.id);
        }, 3000);
        setMessages([...messages, message]);
    }

    const deleteMessage = (event) => {
        setMessages(messages.filter(m => m.id !== event.values))
    }

    return (
        <div className={classes.root}>
            {messages.map(m => (
                <div key={m.id} className={classes.messageCard}>
                    <span className={classes.messageContent}>
                        {m.content}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default Messages;